"use client"
import styles from './play.module.scss'
import { IStation } from '@models'
import Icon from '@components/icon'
import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons'
import Loader from '@components/loader'
import { pause, play } from '@redux/slices/playerSlice'
import { useAppDispatch } from '@redux/hook'
import { usePlayerStatus } from '@hooks'

export default function Play({station, size = 'lg'}: {station: IStation, size: 'sm' | 'lg' }) {
  const dispatch = useAppDispatch()
  const status = usePlayerStatus()
  const togglePlayPause = () => {
    if (status === 'loading') return
    if (status === 'playing') {
      dispatch(pause())
    }
    else {
      dispatch(play(station.url))
    }
  }

  return (
    <div className={`${styles.container} click animated ${styles[size]}`} onClick={togglePlayPause}>
        {
          status === 'loading'? <Loader size={30} color='#fff' />:
          status === 'paused'? <Icon icon={faPlay} />:
          <Icon icon={faPause} className={`aniamted-slow ${styles.active}`} />
        }
    </div>
  )
}
